module.exports = __webpack_public_path__ + "img/director-work-icon5.5d4562b3.png";